import {FormattedMessage} from 'react-intl';
import React, {useState} from 'react';
import moment, {Moment} from 'moment';
import CreateBulkFixedPriceLockMutation from '../../mutations/create_bulk_fixed_price_lock_mutation';
import Util from '../../forecast-app/shared/util/util';
import {getNextAvailableLock} from '../../components/new-ui/project/project-budget-v3/util/PeriodLocks';
import {FlexRow, Modal, SubHeading} from '@forecast-it/design-system';

export type RevenueMonthLockModalProps = {
	closeModal: () => void;
	project: {
		id: string;
		fixedPriceLocks: {
			edges: {
				node: {id: string; startDate: Moment; endDate: Moment; locked: boolean};
			}[];
		};
	};
	month: string;
	lockedAmounts: {
		total: {startDate: Moment; amount: number}[];
		time: {startDate: Moment; amount: number}[];
	};
};

const formatDateISO = (date: moment.Moment) => (date ? date.format('YYYY-MM-DD') : '');
export const RevenueMonthLockModal: React.FC<RevenueMonthLockModalProps> = ({closeModal, project, month, lockedAmounts}) => {
	const nextAvailableLock = getNextAvailableLock(project);

	const [saving, setSaving] = useState(false);

	const onSave = () => {
		if (month && nextAvailableLock) {
			setSaving(true);
			const selectedPeriod = moment(month);

			const totalLockedAmount =
				lockedAmounts.total.find(
					lockedAmount => lockedAmount.startDate.format('YYYY-MM') === selectedPeriod.format('YYYY-MM')
				)?.amount || 0;
			const timeLockedAmount =
				lockedAmounts.time.find(
					lockedAmount => lockedAmount.startDate.format('YYYY-MM') === selectedPeriod.format('YYYY-MM')
				)?.amount || 0;
			const locks = [
				{
					startDate: formatDateISO(selectedPeriod.clone().startOf('month')),
					endDate: formatDateISO(selectedPeriod.clone().endOf('month')),
					locked: true,
					amount: totalLockedAmount,
					timeAmount: timeLockedAmount,
				},
			];
			Util.CommitMutation(CreateBulkFixedPriceLockMutation, {projectId: project.id, locks: locks}, closeModal);
		}
	};

	return (
		<Modal size={Modal.SIZE.MEDIUM} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id="fixed_price_lock.lock_modal_button" />
			</Modal.Title>
			<Modal.Content>
				<FlexRow>
					<SubHeading>
						<FormattedMessage
							id={'fixed_price_lock.lock_message'}
							values={{
								month: moment(month, 'YYYY-MM').format('MMMM YYYY'),
							}}
						/>
					</SubHeading>
				</FlexRow>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={closeModal} dataCy={'modal-btn-rename-report'}>
					<FormattedMessage id={'common.cancel'} />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={onSave} disabled={saving}>
					<FormattedMessage id={'fixed_price_lock.lock_button'} />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};
